import { createApp } from "vue";
import App from "./App.vue";
import Loading from "./components/Loading";

import "@comlinedev/bootstrap5/dist/css/bootstrap.min.css";
import "./assets/bootstrap-theme.css";
import "@comlinedev/bootstrap5/dist/js/bootstrap.bundle.min.js";

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAngleUp,
  faBell,
  faBellExclamation,
  faCheck,
  faCheckDouble,
  faClone,
  faEllipsisH,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faFileImport,
  faFlagCheckered,
  faHourglass,
  faHourglassHalf,
  faKey,
  faLanguage,
  faList,
  faPaperPlane,
  faPlus,
  faQuestionCircle,
  faSignOut,
  faStopwatch,
  faTimes,
  faTrash,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { firebase, region} from "./plugins/firebase";
import { getAuth, onAuthStateChanged} from "firebase/auth";

import router from "./plugins/router";
import i18n from "./plugins/i18n";
import store from "./plugins/store";

library.add(
  faAngleDown,
  faAngleUp,
  faBell,
  faBellExclamation,
  faCheck,
  faCheckDouble,
  faClone,
  faEllipsisH,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faFileImport,
  faFlagCheckered,
  faHourglass,
  faHourglassHalf,
  faKey,
  faLanguage,
  faList,
  faPaperPlane,
  faPlus,
  faQuestionCircle,
  faSignOut,
  faStopwatch,
  faTimes,
  faTrash,
  faUser,
);

let app;
!app && createApp(Loading).mount("#app");

onAuthStateChanged(getAuth(), (user) => {

  store.dispatch("fetchUser", user)
  user && store.dispatch("fetchData")

  if (!app) {
    app = createApp(App)
          .component('font-awesome-icon', FontAwesomeIcon)
          .provide('$router', router)
          .provide('$firebase', firebase)
          .provide('$region', region)
          .use(store)
          .use(router)
          .use(i18n)
          .mount("#app");
  }
  // console.log(user)

})